module.exports = __webpack_public_path__ + "img/Line 80.29cdd5d9.svg";